var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamWork1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.24,381.57c2.92-10.68,12.43-46.53,18.89-82.84,7.7-43.35,14.44-103.06-16.38-128.11s-71.28,4.82-92.47-4.81-22.15-57.8-79-72.24-88.62,35.63-113.66,62.6-53,8.67-89.58,37.57c-36.2,28.58-5.5,158,21.27,187.83Z",
    style: {
      fill: "#06EB83"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.24,381.57c2.92-10.68,12.43-46.53,18.89-82.84,7.7-43.35,14.44-103.06-16.38-128.11s-71.28,4.82-92.47-4.81-22.15-57.8-79-72.24-88.62,35.63-113.66,62.6-53,8.67-89.58,37.57c-36.2,28.58-5.5,158,21.27,187.83Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.21,178.71h-78.5a1.45,1.45,0,0,0-1.44,1.44v202a1.45,1.45,0,0,0,1.44,1.45h78.5a1.45,1.45,0,0,0,1.45-1.45v-202A1.45,1.45,0,0,0,447.21,178.71Zm-1.44,202H370.16V181.6h75.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,223.16h64.65a1.44,1.44,0,0,0,1.44-1.45V187.58a1.43,1.43,0,0,0-1.44-1.44H375.64a1.44,1.44,0,0,0-1.45,1.44v34.13A1.45,1.45,0,0,0,375.64,223.16ZM377.08,189h61.76v31.24H377.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,271.64h64.65a1.43,1.43,0,0,0,1.44-1.44V236.07a1.44,1.44,0,0,0-1.44-1.45H375.64a1.45,1.45,0,0,0-1.45,1.45V270.2A1.44,1.44,0,0,0,375.64,271.64Zm1.44-34.13h61.76v31.25H377.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,320.13h64.65a1.44,1.44,0,0,0,1.44-1.44V284.55a1.44,1.44,0,0,0-1.44-1.44H375.64a1.45,1.45,0,0,0-1.45,1.44v34.14A1.45,1.45,0,0,0,375.64,320.13ZM377.08,286h61.76v31.24H377.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.64,368.62h64.65a1.44,1.44,0,0,0,1.44-1.45V333a1.43,1.43,0,0,0-1.44-1.44H375.64a1.44,1.44,0,0,0-1.45,1.44v34.13A1.45,1.45,0,0,0,375.64,368.62Zm1.44-34.13h61.76v31.24H377.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.88,107H137.44A1.44,1.44,0,0,0,136,108.4V213.72a1.44,1.44,0,0,0,1.45,1.44H348.88a1.43,1.43,0,0,0,1.44-1.44V108.4A1.43,1.43,0,0,0,348.88,107Zm-1.45,2.89v97.72H138.88V109.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.43,315.28,391.88,384a1.39,1.39,0,0,1-1.38,1.29h0a1.37,1.37,0,0,1-1.37-1.42L391,315.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,315.28,412.62,384a1.38,1.38,0,0,0,1.37,1.29h0a1.38,1.38,0,0,0,1.38-1.42l-1.89-68.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.45,315.28,367,384a1.38,1.38,0,0,0,1.37,1.29h0a1.38,1.38,0,0,0,1.38-1.42l-1.9-68.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.86,315.28,339.31,384a1.39,1.39,0,0,1-1.38,1.29h0a1.39,1.39,0,0,1-1.38-1.42l1.9-68.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.13,246s-45.4-1.7-49.24-1.7-4.73,1.7-4.73,1.7l-6.48,45.69s-20.15-5.75-24.1-5,1.95,29.42,1.95,29.42h22.8l.41-1.72h51.48l13.67-65.12C428.06,246.29,423.13,246,423.13,246Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.85,274.58s4.62,30-.68,33.5c-.82.54-5.27,3.1-9.43,2.68-3.34-.34-26.94,0-26.94,0s-3.28-6.24-3.94-10.84,4.5-24.34,4.5-24.34Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.2,290.65s-34.16,3.55-35.77,4.51-9,7.41-7.73,11.6-1.93,4.51,1,5.16,44.46.64,44.46.64",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.13,
    y: 309.99,
    width: 81.17,
    height: 6.06,
    transform: "translate(753.43 626.05) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.13,291.94h-48.9s-2.57,2.9-2.9,9,.33,7.41,4.84,9,44.57.78,44.57.78",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.6,369.54l-5.12-12.13L346.09,359l6.42,10.82-3.7,7.41-8,5.23s-.93.92,3.07.61,12.3,0,12.3,0l5.23-6.15S363.31,373.79,359.6,369.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.84 374.84 362.05 382.77 360.8 382.77 359.13 378.81 361.84 374.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,383.11l5.23-6.15s1.35-2.29-.51-5.59c-3.72,6.36-8.67,8.27-8.67,8.27l-5.16-1.24-6.26,4.1s-.93.92,3.07.61S356.19,383.11,356.19,383.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.49,307.73l17.15,51.85-12.17,2.16-24-54s-1.93-8.06,3.22-10.63,20.3-3.87,20.3-3.87",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,316.05s-5.91-28.71-1.95-29.42,24.1,5,24.1,5L423.13,246s6.84-1.08,7.56,5-13.39,65.05-13.39,65.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.91,231.52l-3.05-5a3.23,3.23,0,0,0-2.81-1.54l-2.87.05-4.91-1.47a1.64,1.64,0,0,0-1.74.55l-.18.23,4.52,2L309.36,228l-4.79-2.43a.9.9,0,0,0-1.13.26h0a.9.9,0,0,0,.16,1.26l6.7,5.17a1.87,1.87,0,0,0,1.5.36l7.41-1.49,2.07,2.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "376.57 221.26 349.1 249.99 322.88 228.8 319.26 231.43 348.11 264.12 373.12 250.65 376.57 221.26",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.67,228.6l14.4,44.25-12.42.36L407.3,252.44S414.24,231.49,417.67,228.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402,221l15.67,7.65-13.12,36.69,1.55,10.23-36.74.06,4.38-16.48-3-10.56a8.09,8.09,0,0,1-.06-4.2l5.88-23.08L392,218.83Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.25,218.85s3.08,2.08,3.18,3.93c.05,1.09,0,3-.1,4.46a9.47,9.47,0,0,1-.77,3.31l-5.55,6.7-6.42-5.07-5.33,2.72s-1-8.17,1.33-13.87S400.06,217.42,401.25,218.85Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.66,203s-1.26,4.53-1.85,7.53-1.78,9-1.67,11.25-9.36,11.83-10.55,10.4-2.44-9.74-2.44-9.74L390.33,209S402.67,195.33,405.66,203Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.87,196s-1.69,2.79-1.69,4,.59,3.58.49,4.27-1.78,3-2,3.78a1.38,1.38,0,0,0,.69,1.69,13.2,13.2,0,0,1,1.19.69s.5,6.16,1.3,7.75,1.49,2.29,3.87,2.49,8.05-2.29,8.84-4.28.9-4.37,1-7.25-1.89-7-3.38-10.93S388.45,192.12,385.87,196Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 411.52,
    cy: 208.71,
    r: 7.63,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,195.57s3.07-2.65,8.59,2.62,3.42,12.89,7.11,14.47,10.52-6.32,11.31-10.26-1.58-12.11-8.95-13.69S387.49,188.21,385.83,195.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.83,195.57a4.1,4.1,0,0,1,4.65-4.49c5,.27,5.52,8.16,8.15,11.32s3.95,2.63,3.95,2.63-4.47,1.31-7.37-.27S390.91,194.27,385.83,195.57Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394,190.16a15.6,15.6,0,0,1,6,6.81c2.27,4.81,2.27,8.78,7.66,8.5,0,0-2.55.57-6.52-1.42s-4.82-7.65-7.37-9.92a8.39,8.39,0,0,0-5.1-2.27",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.84,202.4s-.23,7.22-5.77,8.74",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,209.77s5.28-6.91,6.52-1.75-3,6.42-5,5.83-1.72-1.66-1.72-1.66",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.63,268.9s-10.08,1.4-11.76,1.4-5.88,5.32-5.88,5.32h18.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.45,262.12l3.62,8.16a3.22,3.22,0,0,1-3,4.25l-43.7.25.28-5.88,33.88-5.36",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "369.96 374.84 370.17 382.77 368.92 382.77 367.25 378.81 369.96 374.84",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.72,369.54,366.11,358l-8.38.54,2.9,11.36-3.7,7.41-8,5.23s-.92.92,3.08.61,12.3,0,12.3,0l5.23-6.15S371.43,373.79,367.72,369.54Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.31,383.11l5.23-6.15s1.35-2.29-.52-5.59c-3.72,6.36-8.67,8.27-8.67,8.27l-5.15-1.24-6.27,4.1s-.92.92,3.08.61S364.31,383.11,364.31,383.11Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.88,298.8l3.59,61.32-11.37.27L345,304.68s.21-10.61,3.6-11.83,12.39.09,12.39.09",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.18,166.81l14.11,39.55s-1.86,8.95-7.46,8.58-7.09-8.21-8.58-9.33-3.73-9.7-3.73-9.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.68 158.88 254.74 167.16 263.54 230.77 304.93 230.77 314.18 166.81 289.42 159.06 277.68 158.88",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "279.89 169.78 283.2 174.77 280.33 217.09 284.55 228.11 288.88 217.39 285.17 175.4 288.15 168.19 284.02 162.76 279.89 169.78",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.47 167.72 278.56 172.15 274.67 160.6 277.38 154.75 289.47 154.46 292.42 157.11 291.83 171.85 284.47 167.72",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.72,151.75l-.92,7.43-6.62,8.54-4.95-8.66V145.13S286.9,147.3,290.72,151.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.83,136.31c0-6.75,4.92-12.22,11-12.22s9.45,5.77,9.45,12.52c0,2.18-.45,5.92-.63,7.91-.31,3.4-1.34,4.84-3.35,7.89-6.59,10-12-4.67-14.77-9.6A13.12,13.12,0,0,1,274.83,136.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "290.61 138.43 291.54 145.4 288.27 145.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.91,137.22l-15.72.07a3.67,3.67,0,0,0,.78,3.57c1,1,5.07.65,5.72.39s1-3.12,1-3.12h1.17s.13,3,1.81,3.25,3.87.17,4.29-.13C298.82,140,297.91,137.22,297.91,137.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.77,143.94s3.54,7.25,4.38,9.76,5,4.47,9.21,3.07,3.07-7.63,3.07-7.63-4.47-3.82-5.3-3-5.31,4.47-5.59,3.63-2.23-5.86-2.23-5.86l-.91-3.56,1.87-1.2a1.4,1.4,0,0,0,.25-1.88l-.88-1.27a1.42,1.42,0,0,1-.23-1.08c.23-1.09.86-3.35,2.32-4,2-.83,4.43.38,6.67.94s4.67-1.46,4.67-1.46l1,3.32a15.93,15.93,0,0,0,4.54-7.7c1.12-4.75-10.33-6.7-14-6.7s-9.49,2-11.17,7.26S275.78,143,276.77,143.94Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.83,126.05s2.08,3.12-.65,3.77-8.05-1.69-10.39-.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,132.93s-4.28-.52-6,1.3",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.45,148.7s-3.15,1.64-4.71-.31",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,141.73s-3.09-3.4-3.09.31.93,3.71,2.78,5,2.48-.31,2.48-.31",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.56,372.24h.14l-.27-1.36-13.5-140.1H263.54L249.93,372.23h.15l8.78.75s9.74-32.7,9.74-35.14,2.78-25,2.78-25l13.81-48.55,12.21,48.55s2.78,22.61,2.78,25S309.93,373,309.93,373l8.26-.71h.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 301.84,
    y1: 239.02,
    x2: 292.63,
    y2: 252.17,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 296.91,
    y1: 241.98,
    x2: 291.32,
    y2: 251.19,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 270.61,
    y1: 241.33,
    x2: 278.82,
    y2: 250.2,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 269.95,
    y1: 244.61,
    x2: 281.78,
    y2: 256.45,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266,
    y1: 232.12,
    x2: 302.5,
    y2: 232.12,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.08,372.23s-5.27,4.15-8.31,5.29-8.72,4.17-8.72,4.17,0,1.9,4.93,1.9h19.35L257,372.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.26,381.52a188.23,188.23,0,0,1-23.18-.37l-1,.54s0,1.9,4.93,1.9h19.35Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.76,372.23s5.28,4.15,8.31,5.29,8.73,4.17,8.73,4.17,0,1.9-4.94,1.9H310.52l.35-11.36Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.58,381.52a188.23,188.23,0,0,0,23.18-.37l1,.54s0,1.9-4.94,1.9H310.52Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.74 167.16 239.5 207.85 254.12 207.85 259.58 196.75 254.74 167.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,201.55c-6.1-2.52-25.67-3.77-26.69-3.77s-32.83-2.62-35.44-3-5.6,5.6-5.6,5.6l13.8-.38,16.79,3.36s34,12.31,36.56,11.57a2.28,2.28,0,0,0,.92-.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.32,199.64l52.6-5.22.38,4.47L257.78,212.7s-8.2,1.86-14.55.74-3.35-7.46-1.86-11.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.93 194.42 313 194.04 315.98 200.01 303.3 198.9 302.93 194.42",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M370,282.16l8.59,102.27a1.13,1.13,0,0,0,1.35.94,1.1,1.1,0,0,0,.83-1.18l-5.85-102Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.73,282.16l8.62,102.61a1.12,1.12,0,0,0,1.35.94,1.1,1.1,0,0,0,.83-1.18l-5.87-102.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.49,282.16,185,383.54a1.12,1.12,0,0,0,.84,1.19h0a1.07,1.07,0,0,0,1.33-.92l7.27-101.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.28,282.16l-4.52,101a1.13,1.13,0,0,0,.85,1.19,1.08,1.08,0,0,0,1.33-.92l7.24-101.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.08,
    y: 276.49,
    width: 305.89,
    height: 8.78,
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.08,
    y: 276.49,
    width: 305.89,
    height: 3.01,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.42,
    y: 276.49,
    width: 76.54,
    height: 8.78,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130.35,
    y: 273.57,
    width: 311.34,
    height: 3.35,
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.61,
    y: 273.57,
    width: 76.07,
    height: 3.35,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,273.27h41.78a.81.81,0,0,0,.75-.49L253.8,246.4a.81.81,0,0,0-.75-1.13H211.27a.81.81,0,0,0-.74.48L199,272.13A.81.81,0,0,0,199.7,273.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.62,271.21h35.65a.69.69,0,0,0,.63-.41l9.87-22.51a.69.69,0,0,0-.63-1H213.49a.69.69,0,0,0-.64.42L203,270.24A.69.69,0,0,0,203.62,271.21Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.29,
    y: 271.52,
    width: 62.77,
    height: 2.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.64,
    y: 271.52,
    width: 30.43,
    height: 2.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.16,
    y: 257.25,
    width: 11.07,
    height: 16.36,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,271.38h-1.16a.91.91,0,0,1,0-1.82h1.16a1.74,1.74,0,0,0,1.73-1.73v-4a1.74,1.74,0,0,0-1.73-1.73h-1.49a.91.91,0,1,1,0-1.82h1.49a3.55,3.55,0,0,1,3.55,3.55v4A3.55,3.55,0,0,1,261.74,271.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,273.27H306.94a.81.81,0,0,1-.74-.49L294.63,246.4a.81.81,0,0,1,.74-1.13h41.78a.82.82,0,0,1,.75.48l11.57,26.38A.82.82,0,0,1,348.72,273.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.36,
    y: 271.52,
    width: 62.77,
    height: 2.05,
    transform: "translate(675.49 545.09) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.36,
    y: 271.52,
    width: 43.28,
    height: 2.05,
    transform: "translate(656 545.09) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.74,256.22a2.46,2.46,0,1,1-3.37-1A2.49,2.49,0,0,1,322.74,256.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.37,178.57,130.45,209l14,40.53-4.79,2.74-16.44-37.1-8.21-31.85s-.69-9.58,2.74-11S126,172.41,127.37,178.57Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.49,249.57s3.08,6.51,3.43,8.22.7,5.2-.65,6.76c-1.63,1.88-3.12.43-3.12.43s-4.11-1-4.11-4.45-.34-8.22-.34-8.22Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141.13,
    y1: 259.78,
    x2: 146.9,
    y2: 261.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.51,255.89l1.64,2.58s-3.82,6.53-1.77,4.82,5.88-3.79,5.54-5.5a27.2,27.2,0,0,0-2.28-5.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,142s-3.52-3.8-11.64-1.36-10,15.44-9.75,21.93,6.5,13.81,4.61,17.06-8.94,10.83-8.4,19,7.31,14.62,17.06,11.64S111,195.36,109.06,191s2.17-6.23,3.52-15.71-7.31-17.33-7.31-24.1,7-5.68,7-5.68Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8,167.7c1.28,2.64,2.77,5.46,4.25,8.5,4.94,10.08,1.08,13.72-6.43,19.3S90.83,207.94,92.76,209",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.42,144.67s-10.08.86-12.66,7.29c-1.56,3.91-.36,8.29,1.94,13.39",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.05,206.49a6.06,6.06,0,0,0,2.43.38",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,144s-9.44,1.71-11.58,8.57,10.51,17,11.15,24.46S102.2,188.85,99,194.64c-2.25,4.06-2,8.53.37,10.78",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.22,282.07s-2.33,20.12-4.67,26.54-7.58,56.87-7.87,59.79,7.58,9.62,10.79,11.67,1.75,2.62-1.75,2.91-7.58-.29-9.33-3.5-5.84-4.08-5.84-4.08l-.58,7H114.8l-.87-8.75a10.08,10.08,0,0,1,.87-5.83c1.46-3.21,2-9.92,2-19s-1.75-23.63-.88-30.63,4.38-12.25,4.38-18.08.29-14.58.29-14.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.93,373.65a9.66,9.66,0,0,1,.37-4.49c1.81,3.06,7,7.21,11,8.86a14.59,14.59,0,0,0,6.89,1.16c.47.35.91.65,1.28.89,3.21,2,1.75,2.62-1.75,2.91s-7.58-.29-9.33-3.5-5.84-4.08-5.84-4.08l-.58,7H114.8Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.3,285.28s-5,14.87-9.62,27.7-15.75,42.29-16.92,47.54-1.75,14.88-5,19.84-6.42,7.29-5.84-1.46,5.84-15.17,7-21.88,1.75-30.91,5.83-41.7,8.46-19.54,9-22.75a75.37,75.37,0,0,0,.58-9.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.52,375.15A8.66,8.66,0,0,0,83,379.77c1.68,1.88,4.39-1.77,5.8-4a18.93,18.93,0,0,1-2,4.58c-3.21,4.95-6.42,7.29-5.84-1.46A26.24,26.24,0,0,1,81.52,375.15Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,167.9s-1.75,1.46-2.92,11.38,6.13,40.83,6.13,40.83-12.54,20.54-15.46,30.75-4.67,48.46-4.67,48.46,6.13,2.34,18.67,3.21S137,300.2,137,300.2s.58-54.59.58-63,.59-27.54,1.46-29.87,3.5-8.46,3.5-10.79S125,169.36,125,169.36Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.72,250.86c2.3-8,11.82-29.28,15.22-32.94,5.17,1.72,14.6,3.42,18.81,2.16-.13,3-.2,14.2-.2,17.07,0,8.46-.58,63-.58,63s-6.71,3.21-19.25,2.33-18.67-3.21-18.67-3.21S100.8,261.07,103.72,250.86Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.47,133.52s3.13-6.82,9.32-6.82,8.94,5.5,7.57,10.31,4.12,3.44,4.81,6.54-4.47,5.15-7.22,5.15S122.47,133.52,122.47,133.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.51,132.82c1.84-1,4-1.72,5-.16,1.93,3-4.07,5.36-2.14,8.58s6.65,2.36,6.43,3.43-3.21,1.71-3.21,1.71",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.36,135s.59-.51,1.47-1.13",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.34,149.39a3.12,3.12,0,0,1-1-1.26c-.5-3.69-1.58-7.32-3.62-9.36a19.83,19.83,0,0,0-11.23-5.25,7.91,7.91,0,0,0-3.71.34c-5.31,1.86-9.87,5.53-8.89,14.38,1.08,9.75,8.67,12.19,8.67,12.19l.54,6,7.58,3.52.27-6.5s5.14,2.16,7,1.89,2.44-2.71,3.25-6.23a26.34,26.34,0,0,0,.44-4.87l2.27-2.26C141.2,150.67,139.93,150.35,138.34,149.39Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.87,148.24c-1-8.85,3.58-12.52,8.89-14.38a7.91,7.91,0,0,1,3.71-.34,21.49,21.49,0,0,1,8.12,2.82c-1.52-.31,1.07,4.16-1.31,7a22.13,22.13,0,0,1-7.77,6.22s-2.7-2.17-3.52.81-.54,5.14,1.63,5.69,3,0,3,0-1.44,3.41-4,4.82l0-.49S111,158,109.87,148.24Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.55 168.19 129.1 176.07 113.64 167.9 115.1 160.61 130.55 168.19",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.08,234.63a32.4,32.4,0,0,0,4.86.66c1.27-.08,3-1.51,4.28-.9s3.07,4.46,3.07,4.46,1.7.86,1.21,1.77-2.59,1.75-2.59,1.75-2,1.89-3.16,2.08-8.23-5-8.23-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83,238.37a2.45,2.45,0,0,0-.75-3.74l-19.43-18.2,21.16-32.9a7.61,7.61,0,0,0-13.15-7.65L93.32,212.33a5.06,5.06,0,0,0-.16,7.1l.07.07c1.84,2.84,22.08,17.69,28,19.63A2.43,2.43,0,0,0,123.83,238.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.71,188s2.51,7.77,2.51,9.28a27.44,27.44,0,0,1-.25,3.26l2.21,3.43a1,1,0,0,1-.31,1.34l-3.41,2s-.5,8-1,9-9,.76-9,.76l-2.76,5.26-14.3-5.51,3.76-10.29L177.38,191S186.16,183.24,200.71,188Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.92,206.9s-2.49,2.34-4.36,2.5-7.95-1.25-8.42-1.87-4.67-9.35-4.52-13.56.32-10.44,4.83-12.46,11.69-1.41,15.43-3.74,9.66-4.21,12.78-.16.78,9.66-1.71,12-5.61,3-5.3,4,2.18,2.18,1.09,3.74-5,3-5,3.58.94,2.81-.15,3.12-2.19-2.18-3.28-2.18S188.9,204.88,190.92,206.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.41,199.75a7.91,7.91,0,0,0-1.14,1.66",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.89,183.6a10.32,10.32,0,0,1-5.7,8.08c-4,2.07-9.33,3.76-12.87,6.36",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.65,193.66s-3.55,3-7.35,6.09a32.38,32.38,0,0,1-8.55,4.75",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.67,207.32l2,.5a6.91,6.91,0,0,0,1.51,5.27",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.99,
    y1: 201.95,
    x2: 207.11,
    y2: 198.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.48,198.17l3.22.14s1.11,3.64-2.24,4.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.24,371.06s13,8.21,15.29,8.21,3.43,2.06,2.29,2.29-8.22.45-13,.68-8-.23-10.73-.23-5.94.23-7.31-.45.92-8.45.92-9.82S187.64,370.14,189.24,371.06Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,379.61c-5.05,1.66-13.24.57-18.16.12-3.89-.35-10-.43-12.49-.45-.1,1.17,0,2.06.39,2.28,1.37.68,4.57.45,7.31.45s5.93.46,10.73.23,11.87-.46,13-.68C207.67,381.38,207.25,380.2,206,379.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.51,314.66l-10.26,51.45,2.14,5.34a10.75,10.75,0,0,1-6.49,4.38,49.17,49.17,0,0,1-8.9.92s-1.14-5.71-.45-6.4.91-3.42.91-3.42l5.93-51.82Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.78,369.32s8,6.62,11.65,7.76,7.53,2.28,7.53,3.42-8.67,2.28-15.29,1.6-16.67-3.65-18.95-3.65-1.83-5.94-1.83-6.85S225.08,363.38,230.78,369.32Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,380.5c0-.41-.51-.82-1.32-1.23a70.46,70.46,0,0,1-19.68-.14c-6.57-.94-12.07-2.2-14.88-2.9.24,1.23.71,2.22,1.64,2.22,2.28,0,12.33,3,18.95,3.65S250,381.64,250,380.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.07,291.6a104.15,104.15,0,0,1,20.54.46c11.64,1.37,37.65,3,38.1,5.94s-20.18,64.73-20.18,66.32,1.82,3.2,2.28,4.11a5.29,5.29,0,0,1,.46,2.06s-5.59,6-9.93,7.63-8,.1-8.9.1-.91-6.16-.22-9.13,1.82-10.5,2.05-11.18S228,313.29,228,313.29s-34,5.48-54.31,3.19-22.37-5.47-23.51-10.27,1.14-14.38,1.14-14.38Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.5,306.39a14.93,14.93,0,0,1-1.54,1.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.72,294.11a86.38,86.38,0,0,1-4.53,9.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192,296.4a24.25,24.25,0,0,1-11.87,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.82,309c.78-.3,1.53-.61,2.24-.93",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228,313.29A117.48,117.48,0,0,0,241,310",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,237.48c.48-1.91,1.28-1.76.64-2.39-.88-.88-1.59.16-4.14,1.59s-5.09,3.18-5.09,3.18a2.56,2.56,0,0,1,.63-1.43,6.81,6.81,0,0,0,1-3.5c0-1-.8-.8-1.12.16s-3.18,2.7-3.34,3.5-.73,3.94-.73,3.94c-.91,1.37-.91,7.76-.91,7.76L222.8,264.21l-9.36,11s4.11,6.62,6.39,5.71,3.42-1.83,8.9-6.4c4.64-3.87,16.27-21.72,16.27-21.72a43.2,43.2,0,0,0,5.73-4.3,13.89,13.89,0,0,0,3.46-8.4A10.54,10.54,0,0,1,254.39,237.48Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.65,216.36s1.76-6.6,9.24-5.28,13.2,7.48,14.52,9.68-24.2-.88-24.2-.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.77,274s-1.74,1.88,0,4.84c1.19,2.05,3.29,3.62,7.31,2.93,3.76-.66,9.41-10,9.41-16.57s-4.84-7-6.6-5.72S211.77,274,211.77,274Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.89,215.59s-17.8,8.45-20.31,10-4.11,21.45-4.11,24.88,2.51,37,3.19,42.68,22.6,9.59,29.91,7.53S195,293.43,195,291.6s-.69-17.34-.23-20.31,4.56-15.52,4.56-15.52l12.46,19.88s1.31,2.44,5.94.52c6.62-2.74,7.17-13.33,7.17-13.33s-7.3-12.78-9.36-19.17-3-11.19-3.88-12.33-21.46-10.73-25.11-13.24A16.23,16.23,0,0,0,171.89,215.59Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 199.28,
    y1: 255.77,
    x2: 193.35,
    y2: 247.09,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 198.32,
    y1: 254.53,
    x2: 187.87,
    y2: 249.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,320l9.12,64.82a1.09,1.09,0,0,0,1.33.91h0a1.11,1.11,0,0,0,.84-1.17l-6.43-65.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.15,320.51l-15.24,63.66a1.09,1.09,0,0,0,.91,1.33h0a1.08,1.08,0,0,0,1.2-.78l17.7-61.78Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.83,319.72l-9.7,64.73a1.1,1.1,0,0,0,1,1.26h0a1.09,1.09,0,0,0,1.13-.88l12.31-63.08Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,320l9.12,64.82a1.09,1.09,0,0,0,1.33.91h0a1.11,1.11,0,0,0,.84-1.17L208,318.91Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72,252.73l11.1,72.17h78.94s1.17-20.8-2.31-28.15-46.45,8.41-48,8c-1.15-.29.55-37.55,2.66-52.11a7.22,7.22,0,0,0-7.15-8.25h-28.1A7.22,7.22,0,0,0,126.72,252.73Z",
    style: {
      fill: "#06EB83",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.45,296.75c-3.48-7.35-46.45,8.41-48,8-1.15-.29.55-37.55,2.66-52.11a7,7,0,1,0-13.76.07l11.1,72.17h50.31S217.93,304.1,214.45,296.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.39,237.48s-1.27,1.27-3.18,3.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.19,240.06s-1.55,3.15-2.5,4.58",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.36,276.54c1.66.72,5.71.63,5.72.63s-.87-2.65-.95-2.81c-.89-1.87-3.71-4.94-6-4.63a2.73,2.73,0,0,0-2.19,3.43C37.32,274.74,38.94,275.92,40.36,276.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,262.73c-2.3-.25-5,2.9-5.87,4.79-.07.16-.91,2.84-.87,2.84h0c-.44.49-.9,1-1.39,1.62-.9,1.1-1.9,2.36-2.91,3.8a51.13,51.13,0,0,0-3,4.8,36.59,36.59,0,0,0-2.58,5.8.19.19,0,0,1,0,.07c0-.67,0-2.57,0-2.71-.27-2.05-2-5.85-4.26-6.27A2.73,2.73,0,0,0,69.47,280c-.14,1.63,1,3.26,2.19,4.28,1.3,1.16,4.9,2.28,5.19,2.37A46.8,46.8,0,0,0,75.33,293c-.23,1.24-.41,2.49-.58,3.75,0-.59,0-1.11,0-1.18-.26-2.05-2-5.85-4.25-6.27a2.74,2.74,0,0,0-3.16,2.57c-.13,1.63,1,3.26,2.2,4.29s4.21,2.06,5,2.31c-.06.49-.13,1-.19,1.45-.27,2.32-.54,4.64-.87,6.9-.12.8-.26,1.58-.4,2.36,0-.52,0-.95,0-1-.27-2.05-2-5.85-4.26-6.27a2.74,2.74,0,0,0-3.15,2.58c-.13,1.62,1,3.25,2.2,4.28A17.5,17.5,0,0,0,72.72,311c-.17.8-.34,1.59-.54,2.36-.15.52-.25,1-.43,1.54s-.33,1-.49,1.52c-.35.95-.7,1.94-1.06,2.86-.25.65-.5,1.26-.74,1.87.12-.79.33-2.35.34-2.48a10.66,10.66,0,0,0-1.43-5.17,2.43,2.43,0,0,0,0-.6A2.73,2.73,0,0,0,65,310.57c-2.24.59-3.65,4.51-3.76,6.57,0,.12.08,1.45.14,2.29-.11-.49-.22-1-.34-1.46-.23-1-.5-2-.77-3-.16-.51-.31-1-.47-1.53s-.36-1-.54-1.56c-.44-1.21-.94-2.41-1.48-3.61.86-.21,3.92-1,5.15-1.93s2.52-2.48,2.51-4.11a2.73,2.73,0,0,0-3-2.8c-2.3.25-4.3,3.91-4.71,5.93,0,.13-.17,1.61-.23,2.43-.32-.72-.65-1.44-1-2.16-1-2.06-2.14-4.13-3.23-6.19l-1-1.9c.31-.07,4-.91,5.34-2s2.52-2.47,2.51-4.11a2.74,2.74,0,0,0-3-2.8c-2.3.25-4.29,3.91-4.71,5.93,0,.16-.23,2.29-.25,2.84-.72-1.39-1.43-2.79-2.07-4.19a48.24,48.24,0,0,1-2.26-5.83c.14,0,4-.9,5.38-2,1.22-.94,2.52-2.48,2.5-4.11a2.73,2.73,0,0,0-3-2.8c-2.3.25-4.29,3.91-4.71,5.93,0,.16-.24,2.46-.25,2.88,0-.12-.08-.23-.12-.35a35.9,35.9,0,0,1-1.17-6.15c-.12-1.15-.18-2.25-.22-3.33.73-.09,4-.53,5.43-1.36s2.78-2.19,3-3.81a2.74,2.74,0,0,0-2.63-3.11c-2.32,0-4.7,3.42-5.34,5.38,0,.11-.26,1.23-.42,2.05,0-.48,0-1,0-1.45,0-1.75.11-3.35.22-4.76.07-.81.15-1.54.23-2.22.67-.46,3.34-2.34,4.16-3.69s1.46-3.22.86-4.74a2.73,2.73,0,0,0-3.76-1.54c-2.06,1.06-2.6,5.19-2.26,7.23,0,.17.81,2.87.84,2.85l0,0c-.09.65-.18,1.35-.26,2.12-.14,1.42-.28,3-.33,4.78a50,50,0,0,0,.14,5.66,35.75,35.75,0,0,0,1,6.26.19.19,0,0,1,0,.07c-.36-.57-1.43-2.13-1.53-2.24-1.35-1.56-4.88-3.79-7-2.88a2.73,2.73,0,0,0-1.22,3.88c.79,1.43,2.67,2.14,4.2,2.36,1.72.25,5.34-.8,5.63-.88a48.78,48.78,0,0,0,2.19,6.08c.5,1.15,1,2.3,1.59,3.44-.33-.49-.63-.92-.67-1-1.35-1.56-4.88-3.79-7-2.88A2.73,2.73,0,0,0,42.28,297c.78,1.43,2.67,2.14,4.19,2.36s4.65-.6,5.47-.84c.22.44.43.88.65,1.31,1,2.09,2.11,4.17,3.08,6.24.34.73.65,1.46,1,2.19l-.59-.84c-1.35-1.56-4.88-3.78-7-2.88a2.74,2.74,0,0,0-1.21,3.89c.79,1.43,2.67,2.14,4.19,2.36a17.68,17.68,0,0,0,5.33-.8c.3.76.6,1.52.85,2.26.17.52.36,1,.49,1.53s.29,1,.43,1.54c.24,1,.49,2,.7,3,.15.67.28,1.32.41,2-.34-.73-1-2.15-1.09-2.26-1.1-1.75-4.25-4.48-6.49-3.91a2.74,2.74,0,0,0-1.78,3.66c.56,1.53,2.31,2.52,3.78,3,1.63.49,5.22,0,5.67,0,.22,1.07.41,2.12.59,3.11.6,3.43,1,6.32,1.21,8.33,0,.36.08.68.11,1h-7l2.54,49.57H69.67l2.54-49.57H65.72l.15-.29c.89-1.86,2.12-4.52,3.45-7.78.43-1,.86-2.13,1.29-3.27.44.09,4,.81,5.65.43,1.51-.34,3.33-1.19,4-2.67a2.73,2.73,0,0,0-1.51-3.78c-2.19-.74-5.53,1.75-6.76,3.41-.07.1-.74,1.25-1.15,2l.53-1.4c.35-.95.67-1.92,1-2.95l.45-1.53c.17-.51.28-1.06.42-1.6.29-1.25.53-2.53.75-3.83.83.3,3.82,1.34,5.36,1.23s3.47-.67,4.36-2a2.74,2.74,0,0,0-.92-4c-2-1-5.74.9-7.2,2.35-.09.1-1,1.26-1.52,1.91.12-.78.24-1.56.34-2.36.29-2.29.5-4.62.73-6.94.07-.71.15-1.42.22-2.13.3.11,3.82,1.42,5.55,1.3,1.53-.11,3.46-.67,4.35-2a2.74,2.74,0,0,0-.92-4c-2-1.05-5.73.9-7.2,2.35-.11.11-1.45,1.79-1.77,2.23.17-1.56.35-3.11.59-4.64a47.09,47.09,0,0,1,1.33-6.1c.14,0,3.8,1.43,5.58,1.31,1.53-.11,3.46-.68,4.35-2a2.73,2.73,0,0,0-.92-4c-2-1.06-5.73.89-7.2,2.35-.11.11-1.55,1.92-1.79,2.26l.09-.35a35.54,35.54,0,0,1,2.42-5.78c.53-1,1.09-2,1.65-2.9.66.33,3.68,1.8,5.28,1.86s3.52-.29,4.56-1.55a2.73,2.73,0,0,0-.48-4c-1.93-1.28-5.8.25-7.41,1.54-.09.07-.91.88-1.49,1.48.26-.41.52-.84.78-1.22,1-1.46,1.94-2.73,2.82-3.86.5-.63,1-1.19,1.41-1.71.81,0,4.08-.12,5.51-.79s3-1.88,3.33-3.47A2.73,2.73,0,0,0,93.51,262.73ZM68.06,324.48c-1.39,3.2-2.67,5.81-3.58,7.62l-.51,1h-.15c0-.35-.1-.74-.16-1.17-.28-2-.72-4.94-1.41-8.39-.21-1.09-.46-2.25-.73-3.44a30.66,30.66,0,0,0,3.16-1.49,20,20,0,0,0,4.61,3C68.88,322.58,68.46,323.56,68.06,324.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,277.43s.74-2.69.76-2.87c.29-2.05-.36-6.16-2.45-7.17A2.74,2.74,0,0,0,76,269c-.56,1.53.15,3.41,1,4.71C78,275.27,81.4,277.43,81.4,277.43Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.18,
    y: 382.58,
    width: 406.75,
    height: 4.98,
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamWork1);
export default __webpack_public_path__ + "static/media/TeamWork1.b44de6a49d7bd1004715d595d0e7ecd7.svg";
export { ForwardRef as ReactComponent };